import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import { LuHome, LuTrophy, LuBarChart2, LuDatabase, LuFileText, LuUsers, LuHelpCircle, LuMail } from 'react-icons/lu';

function MobileMenu() {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    return (
        <div className="header_wrapper">
            <div className="wrapper">
                <button
                    id="nav_icon3"
                    type="button"
                    className={isOpen ? 'menu_icon open' : 'menu_icon'}
                    aria-expanded={isOpen}
                    aria-controls="mobile_menu"
                    aria-label="Toggle navigation menu"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <input type="checkbox" id="toggle" checked={isOpen} readOnly />
                <div className="mobile_overlay" onClick={() => setIsOpen(false)}></div>
                <nav id="mobile_menu" onClick={() => setIsOpen(false)}>
                    <ul>
                        <li>
                            <Link className="nav_link" to="/">
                                <LuHome className="menu_item_icon" /> Home
                            </Link>
                        </li>
                        <li>
                            <Link className="nav_link" to="/contest">
                                <LuTrophy className="menu_item_icon" /> Contest
                            </Link>
                        </li>
                        <li>
                            <Link className="nav_link" to="/leaderboard">
                                <LuBarChart2 className="menu_item_icon" /> Leaderboard
                            </Link>
                        </li>
                        <li>
                            <a className="nav_link" href="/documentation/en/user_guide/data.html">
                                <LuDatabase className="menu_item_icon" /> Data
                            </a>
                        </li>
                        <li>
                            <a className="nav_link" href="/documentation/en/">
                                <LuFileText className="menu_item_icon" /> Docs
                            </a>
                        </li>
                        <li>
                            <a className="nav_link" href="/community">
                                <LuUsers className="menu_item_icon" /> Community
                            </a>
                        </li>
                        <li>
                            <Link className="nav_link" to="/faq">
                                <LuHelpCircle className="menu_item_icon" /> FAQ
                            </Link>
                        </li>
                        <li>
                            <Link className="nav_link" to="/contacts">
                                <LuMail className="menu_item_icon" /> Contact
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    );
}

export default MobileMenu;
